import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent implements OnInit {
  routeSubs: Subscription;
  isHome: boolean;
  linkActve = {
    hm: false,
    tch: false,
    stud: false,
    acc: false,
    fee: false,
    rec: false,
    set: false
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    /* this.routeSubs = this.activatedRoute.params.subscribe((param: Params) => {
      this.activatedRoute.params.subscribe((param: Params) => {
        this.isHome = param["branch"] === "branch";
        console.log(this.isHome + "home");
      });
    });*/
  }
  onAddNavigation(link: string, page: string) {
    if (link === "headmisstress") {
      this.linkActve = {
        hm: true,
        tch: false,
        stud: false,
        acc: false,
        fee: false,
        rec: false,
        set: false
      };
    } else if (link === "teachers") {
      this.linkActve = {
        hm: false,
        tch: true,
        stud: false,
        acc: false,
        fee: false,
        rec: false,
        set: false
      };
    }
    if (link === "students") {
      this.linkActve = {
        hm: false,
        tch: false,
        stud: true,
        acc: false,
        fee: false,
        rec: false,
        set: false
      };
    }
    if (link === "accountant") {
      this.linkActve = {
        hm: false,
        tch: false,
        stud: false,
        acc: true,
        fee: false,
        rec: false,
        set: false
      };
    }
    if (link === "fees") {
      this.linkActve = {
        hm: false,
        tch: false,
        stud: false,
        acc: false,
        fee: true,
        rec: false,
        set: false
      };
    }
    if (link === "reception") {
      this.linkActve = {
        hm: false,
        tch: false,
        stud: false,
        acc: false,
        fee: false,
        rec: true,
        set: false
      };
    }
    if (link === "profile") {
      this.linkActve = {
        hm: false,
        tch: false,
        stud: false,
        acc: false,
        fee: false,
        rec: false,
        set: true
      };
    }

    this.router.navigate(["br", link, page]);
  }
  onLogout() {
    this.authService.onLogout();
  }
}
